<!-- 物流卡片 -->
<template>
  <div class="card">
    <div class="express-name">
      <h1>
        <span class="flag">{{ deliveryStatus[Number(info.deliveryStatus)] }}</span
        ><span class="name">{{ info.expressName }}</span
        ><b>{{ info.expressNo }}</b>
      </h1>
      <button @click="openDeliver()">查看物流</button>
    </div>
    <div class="course">
      <p v-for="(item, index) in info.goodsNameList" :key="index">
        <span v-if="index < showNum"> {{ item }}</span>
      </p>
    </div>
    <div class="more" @click="openMore" v-if="info.goodsNameList.length > 2">
      <span>{{ show ? '收起' : '更多' }}</span>
      <van-icon v-show="!show" name="arrow-down" />
      <van-icon v-show="show" name="arrow-up" />
    </div>
    <LogisticsDetail :showDetail="showDetail" :deliverData="info" @close="close" />
  </div>
</template>

<script>
import LogisticsDetail from './logisticsDetail.vue';

export default {
  data() {
    return {
      show: false,
      showDetail: false,
      showNum: 2, // 默认展示2条
      deliveryStatus: {
        0: '揽件中',
        1: '在途中',
        2: '派件中',
        3: '已签收',
        4: '派送失败',
        5: '疑难件',
        6: '退件签收',
      },
    };
  },
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  components: { LogisticsDetail },

  computed: {},

  mounted() {},

  created() {},

  methods: {
    openMore() {
      this.show = !this.show;
      this.showNum = !this.show ? 2 : this.info.goodsNameList.length;
    },
    openDeliver() {
      this.$emit('setDisabled', true);
      this.showDetail = !this.showDetail;
    },
    close() {
      this.$emit('setDisabled', false);
      this.showDetail = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.card {
  position: relative;
  width: 670px;
  margin: 0 auto 20px;
  padding: 36px 0 36px 36px;
  background: #fff;
  border-radius: 16px;
  .express-name {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0 24px 0;
    h1 {
      display: flex;
      align-items: center;
      .flag {
        padding: 2px 5px;
        color: #ff6c02;
        font-weight: 400;
        font-size: 24px;
        border: 2px solid #ff6c02;
        border-radius: 8px;
      }
      .name {
        padding: 0 10px;
        color: #333;
        font-weight: 800;
        font-size: 28px;
      }
      b {
        display: inline-block;
        width: 240px;
        overflow: hidden;
        color: #787878;
        font-size: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    button {
      height: 40px;
      padding: 0 12px;
      color: #fff;
      font-size: 22px;
      line-height: 40px;
      text-align: center;
      background: #ff6c02;
      border: none;
      border-radius: 37px 0 0 37px;
    }
  }
  .course {
    p {
      padding: 0 0 16px 0;
      line-height: 40px;
      span {
        display: inline-block;
        width: 580px;
        overflow: hidden;
        color: #787878;
        font-size: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .more {
    display: flex;
    justify-content: center;
    margin: 10px 0 0 0;
    span {
      padding: 0 5px 0 0;
      color: #a5a5a5;
      font-size: 24px;
    }
    ::v-deep .van-icon {
      position: relative;
      top: -2px;
      color: #a5a5a5;
      font-size: 15px;
    }
  }
}
</style>
